import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  heading: {
    marginRight: theme.spacing(2),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  menuAcao: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  pageTitle: {
    fontSize: theme.typography.h6.fontSinze,
  },
  item: {
    padding: theme.spacing(1),
  },
}))

export default useStyles
